<template>
<div>

  <vue-headful
    title="TZ Design Box - Page not found"
    description="TZ Design Box"
/>

    <h2> {{ $t("page-not-found") }} </h2>
</div>
</template>

<script>
export default {
name: 'NotFound',
    created(){ 
        var self = this;
          if(localStorage.getItem("language")){
            this.$i18n.locale = localStorage.getItem("language");
            }
    }
}
</script>

<style>
</style>
